import React from "react"

import {TOption} from "../../components/formElements/Dropdown/types.ts"
import {TOrderBy} from "../../components/Table/utils/shared.ts"
import {ASaasCompanyUserListItem, AUsersListParamsStatusEnum} from "../../services/types.generated.ts"
import {createSimpleContext, createStateContext} from "../../utils/context.tsx"
import {useArrayFilterProperty, useFilterProperties, useStringFilterProperty} from "../../utils/filters.ts"
import {TColumn} from "./table/SaaSUserManagementTable.tsx"

export const InviteUsersModalContext = createStateContext<boolean>("invite users modal")

export const CancelInvitationContext = createStateContext<ASaasCompanyUserListItem | null>("cancel invitation")
export const ReactivateUserContext = createStateContext<ASaasCompanyUserListItem | null>("reactivate user")
export const DeactivateUserContext = createStateContext<ASaasCompanyUserListItem | null>("deactivate user")

export const FilteringContext = createSimpleContext<ReturnType<typeof useSaasUserManagementTableFiltering>>("filtering")

export const useSaasUserManagementTableFiltering = () => {
  const [orderBy, setOrderBy] = React.useState<TOrderBy<TColumn>>(undefined)

  const filterProperties = useFilterProperties({
    searchString: useStringFilterProperty(),
    status: useArrayFilterProperty<Array<TOption<AUsersListParamsStatusEnum>>>(),
  })

  return {
    ...filterProperties,
    orderBy,
    setOrderBy,
  }
}
